"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgEdit3 = function SvgEdit3(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M33 31.121a1 1 0 110 2h-9a1 1 0 110-2zM30.81 14.106a3.121 3.121 0 011.399 5.222l-12.5 12.5a1 1 0 01-.465.264l-4 1a1 1 0 01-1.212-1.213l1-4a1 1 0 01.263-.465l12.5-12.5a3.121 3.121 0 013.015-.808zm-1.601 2.222L16.904 28.633l-.529 2.114 2.115-.529 12.304-12.304a1.121 1.121 0 10-1.586-1.586z",
    id: "edit-3_svg__a"
  }));
};

var _default = SvgEdit3;
exports["default"] = _default;